// Translation dictionary. Scope: the entire Tapaswe Global parent
// site (nav, footer, Home, Trusted Ecosystem, Promises, Values,
// Solutions, iTrust.ID coming-soon, Markets + all 3 entity pages,
// Invest, Contact, legal pages, 404). DeviceWorks is out of scope —
// it's its own brand and stays English-only by design.
//
// Brand/entity names are never translated: iTrust.ID, DeviceWorks,
// Tapaswe Global, Tapaswe Bharat, Tapaswe USA. Everything
// else is.
//
// IMPORTANT: the Hindi and Spanish strings here were AI-translated,
// not reviewed by a native/professional speaker. Treat as a starting
// draft — have someone fluent in each language check tone and
// accuracy before this is customer-facing in that market.

const translations = {
  en: {
    nav: {
      trustedEcosystem: "Trusted Ecosystem",
      solutions: "Solutions",
      markets: "Markets",
      invest: "Invest",
    },
    footer: {
      company: "Company",
      solutions: "Solutions",
      markets: "Markets",
      contactUs: "Contact Us",
      invest: "Invest",
      careers: "Careers",
      promise: "Our Promise",
      values: "Core Values",
      legalTrust: "Legal & Trust",
      dataSovereignty: "Data Sovereignty",
      privacyPolicy: "Privacy Policy",
      termsOfUse: "Terms of Use",
      copyright: "© 2026 Tapaswe, Global Partners and Affiliates",
    },
    home: {
      heroTitleLine1: "Trust,",
      heroTitleLine2: "built to last.",
      heroSub:
        "We build the platforms. Local teams, led by local CEOs, operate them — market by market — to grow trusted ecosystems in the communities we serve.",
      ctaMission: "Our Mission",
      solutionsEyebrow: "Our Solutions",
      solutionsHeading: "What we've built so far",
      seeAllSolutions: "See all solutions",
      marketsEyebrow: "Two Markets, Today",
      marketsHeading: "Operating in India & the USA",
      seeAllMarkets: "See all markets",
    },
    trustedEcosystem: {
      eyebrow: "Our Mission",
      headingLine1: "Trusted Ecosystems,",
      headingLine2: "everywhere we operate.",
      intro:
        "Tapaswe Global exists to build trusted ecosystems in every community we enter. Trust isn't a feature we add — it's the reason the company exists. Headquartered in India, we're building out from two markets today: India and the USA.",
      structureEyebrow: "How We're Structured",
      structureHeading: "One parent, local operators.",
      structureIntro:
        "Tapaswe Global builds the platforms — iTrust.ID and DeviceWorks. Each market we operate in is run by a semi-independent local business, led by a local CEO, that owns the actual services and customer relationships in that market, using the platforms we build centrally. Global builds; local operates.",
      model: [
        "Global builds the platforms",
        "Local businesses operate them",
        "Local CEOs drive market growth",
        "More markets, more solutions ahead",
      ],
      nextEyebrow: "What's Next",
      nextHeading: "Growing the map and the basket.",
      nextIntro:
        "India and the USA are where we're starting, not where we stop. Russia and Australia are next on the roadmap, and we plan to keep growing our basket of solutions well beyond iTrust.ID and DeviceWorks over time.",
    },
    promises: {
      headingLine1: "Our",
      headingLine2: "Promise",
      intro:
        "We promise a no-nonsense approach, transparent partnership, and commitment to create and deliver shared value. Your success today and evolution tomorrow is our mission.",
      items: [
        { title: "Outcome. Guaranteed.", body: "Aspire, act, measure, and track to deliver committed outcomes." },
        { title: "Reward & Risk. Shared.", body: "Partner for shared success and manage risks openly, jointly & effectively." },
        { title: "Reach. Global.", body: "Energize your life and business with global partners, talent and solutions." },
        { title: "Partners. Friendly.", body: "Enjoy transparency, honesty and collaboration to foresee and avoid failures." },
        { title: "Experience. Mile Wide.", body: "Learn, level up, and embrace sustainable change successfully." },
        { title: "Expertise. Mile Deep.", body: "Ride legacy, maturing, leading, and emerging ideas, technologies, and solutions." },
        { title: "Time to success. Agile.", body: "Dynamic plan, hyper automation and continuous course correction." },
      ],
    },
    values: {
      headingLine1: "Core",
      headingLine2: "Values",
      intro: "Core values drive culture and focus. We have some of our own light houses and north star.",
      items: [
        { title: "Eternal = Renewal", body: "Just like nature, we create, nurture and recycle to renew continuously and stay relevant" },
        { title: "Human = Heart", body: "Committed to promoting merit, choice, equality, and inclusion in everything we do." },
        { title: "Matter = Mind", body: "Mind determines matter, reality and focus. Awareness propels us everyday towards our purpose." },
        { title: "Fun = Now", body: "Enjoy life and work now to stay above pride from past and purpose from future." },
        { title: "Relation = Reciprocity.", body: "Relation is for equals. Forgive judgement errors. Act on intent errors." },
        { title: "Family = Trust", body: "Building shared trust is at the heart of how we collaborate, learn and succeed together." },
        { title: "Team = Network", body: "One for all. All for one. Entire ecosystem operates as distributed global team with purpose." },
      ],
    },
    solutions: {
      eyebrow: "Built by Tapaswe Global",
      headingLine1: "Two platforms.",
      headingLine2: "Two real problems.",
      intro:
        "Each solution is built centrally, then operated and serviced locally in every market we're in. Each has its own brand and its own site — but they're designed to work together where it makes sense.",
      dwBody: "DeviceWorks manages the full lifecycle of every kind of device and its field services, leveraging OEM and service partners alongside our own analytics platform.",
      dwButton: "Visit DeviceWorks",
      itBody: "In a world where AI makes everything virtual and easy to fake, iTrust.ID exists to establish trust — of people, identities, and claims — in every domain, everywhere.",
      itButton: "Visit iTrust.ID",
      comingSoon: "Coming Soon",
      moreEyebrow: "More Coming",
      moreHeading: "The basket keeps growing.",
      moreIntro: "These two are just the start of our solution portfolio.",
    },
    itrustComingSoon: {
      badge: "Coming Soon",
      intro1: "Trust for everyone, everywhere. In a world where AI makes everything virtual and easy to fake, iTrust.ID exists to establish trust — of people, identities, and claims — in every domain, everywhere.",
      intro2: "The iTrust.ID site and platform are in development. Check back soon, or explore our other solution, DeviceWorks, in the meantime.",
      btnDeviceWorks: "Visit DeviceWorks",
      btnBackSolutions: "Back to Solutions",
      problemEyebrow: "The Problem",
      problemHeading: "As the world goes virtual, trust runs short.",
      problemBody: "Deepfakes, synthetic identities, and AI-generated everything are making it harder to know what — and who — is real. iTrust.ID exists to be the one place you go to establish, verify, and manage trust, for every part of your life.",
      pillarsEyebrow: "Four Pillars",
      pillarsHeading: "One place for everything you trust.",
      dashboardTitle: "Dashboard",
      dashboardBody: "Your active devices, your locations, and every authentication request — all in one view, all under your control.",
      lifeTitle: "Life",
      lifeBody: "Your living identity: documents, health records, financial accounts, education credentials, and everything else that makes up your verified life.",
      peopleTitle: "People",
      peopleBody: "Your connected communities: social circles, businesses, organizations, family, and professional relationships — each with its own trust standing.",
      thingsTitle: "Things",
      thingsBody: "Everything that acts on your behalf or around you: agents, devices, bots, servers, equipment, and drones.",
      lifecycleEyebrow: "Every Item, Fully Governed",
      lifecycleHeading: "The full trust lifecycle, applied everywhere.",
      lifecycleBody: "Add, configure, and remove anything across all four pillars — with every item tracked, audited, governed, and certifiable, start to finish.",
      trackingTitle: "Tracking",
      auditTitle: "Audit",
      governanceTitle: "Governance",
      certificationTitle: "Certification",
    },
    markets: {
      eyebrow: "Global Parent, Local Operators",
      headingLine1: "Three entities.",
      headingLine2: "One trusted ecosystem.",
      intro: "One global parent builds the platforms. Local, semi-independent businesses — each with its own brand and its own local CEO — deliver them as real services on the ground.",
      globalDesc: "Owner of all solutions. Mumbai, Maharashtra.",
      globalBtn: "View Global",
      bharatDesc: "India operations. Mumbai, Maharashtra.",
      bharatBtn: "View Bharat",
      usaDesc: "USA operations. Philadelphia & Charlotte.",
      usaBtn: "View USA",
      planned: "Planned",
      plannedDesc: "Next on our market roadmap.",
      sovereigntyEyebrow: "Built On Data Sovereignty",
      sovereigntyHeading: "Your data stays where you do.",
      sovereigntyBody: "Each market runs on its own independent infrastructure — its own database, its own services, hosted in that market's own region. Nothing is shared across borders by default. Read our full commitment on the Data Sovereignty page.",
    },
    marketProfile: {
      headquarters: "Headquarters",
      offices: "Offices",
      office: "Office",
      localLeadership: "Local Leadership",
      executiveLeadership: "Executive Leadership",
      solutionsTitle: "Solutions",
    },
    marketsGlobal: {
      intro: "Tapaswe Global is the parent entity — it builds and owns every solution in the Tapaswe portfolio, including iTrust.ID and DeviceWorks. Local operating businesses in each market deliver those platforms as real services on the ground.",
      solutionsNote: "Owns & builds: iTrust.ID · DeviceWorks",
    },
    marketsIndia: {
      intro: "Tapaswe Bharat operates as a semi-independent subsidiary of Tapaswe Global, delivering iTrust.ID and DeviceWorks as real services across India, under a local CEO.",
    },
    marketsUsa: {
      intro: "Tapaswe USA operates as a semi-independent subsidiary of Tapaswe Global, delivering iTrust.ID and DeviceWorks as real services across the USA, under a local CEO.",
    },
    invest: {
      eyebrow: "For Investors",
      heading: "Building the infrastructure of trust.",
      intro: "Tapaswe Global builds trust platforms centrally and grows them through semi-independent, locally-led operating businesses — starting in India and the USA, with Russia and Australia next.",
      portfolioTitle: "Portfolio",
      portfolioBody: "iTrust.ID and DeviceWorks — with more solutions planned.",
      marketsTitle: "Markets",
      marketsBody: "Live in India and the USA. Russia and Australia are next.",
      modelTitle: "Model",
      modelBody: "Global builds platforms; local, CEO-led businesses operate and grow them.",
      getInTouchEyebrow: "Get in Touch",
      heading2: "Investor Inquiries",
      subIntro: "Interested in learning more about investing in Tapaswe Global? Send us a note.",
      namePlaceholder: "Name",
      emailPlaceholder: "Email",
      investorTypePlaceholder: "Investor type",
      citizens: "Citizens",
      smb: "Small & Medium Businesses",
      corporations: "Corporations",
      governments: "Governments",
      countryPlaceholder: "Country",
      messagePlaceholder: "Message",
      sendingBtn: "Sending…",
      sendBtn: "Send Inquiry",
      sentMessage: "Thanks — your inquiry has been received. We'll be in touch.",
    },
    contact: {
      eyebrow: "Get in Touch",
      heading: "Contact Us",
      intro: "We'd like to hear from you — whether you're a partner, a customer, or curious about what we're building.",
      namePlaceholder: "Name",
      emailPlaceholder: "Email",
      entityPlaceholder: "Which entity is this for?",
      entityGlobal: "Tapaswe Global — Global HQ",
      entityBharat: "Tapaswe Bharat — India",
      entityUsa: "Tapaswe USA — USA",
      entityOther: "Others",
      messagePlaceholder: "Message",
      sendingBtn: "Sending…",
      sendBtn: "Send",
      sentMessage: "Thanks — your message has been received. We'll get back to you shortly.",
    },
    legalDataSovereignty: {
      title: "Data Sovereignty",
      sections: [
        { heading: "Coming Soon", body: "Our full Data Sovereignty commitments are being finalized and will be published here soon. Each market we operate in runs on its own independent infrastructure, hosted in that market's own region." },
      ],
    },
    legalPrivacy: {
      title: "Privacy Policy",
      sections: [
        { heading: "Coming Soon", body: "Our Privacy Policy is being finalized and will be published here soon." },
      ],
    },
    legalTerms: {
      title: "Terms of Use",
      sections: [
        { heading: "Coming Soon", body: "Our Terms of Use are being finalized and will be published here soon." },
      ],
    },
    noPage: {
      heading: "Page Not Found",
      body: "The page you're looking for doesn't exist or has moved.",
      button: "Back to Home",
    },
    legalPage: {
      eyebrow: "Legal",
    },
    deviceworks: {
      navMarketplace: "Marketplace",
      navCompare: "Compare",
      navLifecycle: "Lifecycle",
      navHowWeWork: "How We Work",
      navGetAQuote: "Get a Quote",
      home: {
        eyebrow: "Device Lifecycle, Simplified",
        heroTitleLine1: "Every device.",
        heroTitleLine2: "One partner.",
        heroSub: "DeviceWorks manages the full lifecycle of every kind of device and its field services — leveraging OEM and service partners alongside our own analytics platform, so you deal with one accountable partner instead of a dozen.",
        ctaQuote: "Get a Quote",
        ctaHowWeWork: "How We Work",
        pullQuote: "\"The device fleet shouldn't be the thing operations has to think about. It should just work — and when it doesn't, someone should already be on it.\"",
        howItWorksEyebrow: "How It Works",
        howItWorksHeading: "Three steps, start to finish",
        step1Title: "Tell us what you need",
        step1Body: "Devices, volume, timeline — we scope it with you.",
        step2Title: "We coordinate execution",
        step2Body: "Sourcing, deployment, and field service handled through our partner network.",
        step3Title: "You get one dashboard",
        step3Body: "Analytics and status across every device, every partner, one place.",
        marketplaceComingSoon: "Coming Soon",
        marketplaceTitle: "Device Marketplace",
        marketplaceBody: "New, certified refurbished, and OEM devices — curated by category.",
        marketplaceLink: "Explore the marketplace",
        lifecycleTitle: "Lifecycle Services",
        lifecycleBody: "Procurement, ongoing management, repair, and end-of-life — end to end.",
        lifecycleLink: "See all services",
        industriesEyebrow: "Who We Serve",
        industriesHeading: "Industries",
        industryRetail: "Retail",
        industryDistribution: "Distribution",
        industryWarehousing: "Warehousing",
        industryManufacturing: "Manufacturing",
        ctaHeading: "Ready to simplify your device fleet?",
        ctaSub: "Tell us what you're working with — we'll take it from there.",
        ctaButton: "Get a Quote",
      },
      pageHeaders: {
        marketplace: { eyebrow: "Coming Soon", title: "Device Marketplace", description: "A curated preview of what's coming — not yet a live, browsable catalog. Here's what to expect." },
        compare: { eyebrow: "Compare Devices", title: "Find the right fit", description: "Ten quick questions — we'll point you toward the right category." },
        lifecycleServices: { eyebrow: "What We Do", title: "Lifecycle Services", description: "Four service lines, one accountable partner, start to finish." },
        howWeWork: { eyebrow: "Operating Model", title: "How We Work", description: "Two supply chains, working together, managed as one." },
        insights: { eyebrow: "Insights", title: "Notes on device operations" },
        industries: { eyebrow: "Who We Serve", title: "Industries We Serve" },
        oemPartners: { eyebrow: "Retail Focus — Expanding to All Sectors", title: "OEM Partners", description: "We work across device manufacturers rather than tying you to one — vendor neutrality is core to how we advise." },
        logisticsPartners: { eyebrow: "Physical Supply Chain", title: "Logistics Partners", description: "Capabilities our logistics network provides — no partner names listed here by design, consistent with our vendor-neutral approach." },
        getAQuote: { eyebrow: "Get a Quote", title: "Tell us what you need", description: "A few details and our team will follow up with next steps." },
        contact: { eyebrow: "Get in Touch", title: "Contact Us" },
        about: { eyebrow: "About Us", title: "Why DeviceWorks exists" },
        locations: { eyebrow: "Where We Are", title: "Locations" },
        login: { eyebrow: "Coming Soon", title: "Client Login", description: "The DeviceWorks analytics platform is in development." },
      },
    },
    careers: {
      eyebrow: "Join Us",
      heading: "Open Roles",
      intro: "We're a small, deliberately-built team. These three roles are open right now.",
      roleBharatTitle: "Chief Executive Officer",
      roleBharatEntity: "Tapaswe Bharat",
      roleBharatLocation: "Mumbai, Maharashtra",
      roleBharatBody: "Lead our India operating business full-time — the role is currently held on an acting basis by our Chief Trust Officer.",
      roleUsaTitle: "Chief Executive Officer",
      roleUsaEntity: "Tapaswe USA",
      roleUsaLocation: "Philadelphia, PA or Charlotte, NC",
      roleUsaBody: "Lead our USA operating business — building the local team, growing our two solutions in-market, and reporting into the Tapaswe Global structure.",
      roleGlobalTitle: "Chief Product Officer",
      roleGlobalEntity: "Tapaswe Global",
      roleGlobalLocation: "Mumbai, Maharashtra",
      roleGlobalBody: "Own product direction across our solution portfolio — iTrust.ID, DeviceWorks, and what comes next — working directly with the parent company's leadership.",
      applyHeading: "Apply",
      applySub: "Tell us a bit about yourself and which role you're applying for.",
      namePlaceholder: "Name",
      emailPlaceholder: "Email",
      rolePlaceholder: "Which role?",
      linkPlaceholder: "Link to resume, LinkedIn, or portfolio (optional)",
      attachmentsLabel: "Attachments",
      attachmentsHint: "Resume, cover letter, portfolio — multiple files welcome.",
      messagePlaceholder: "Message",
      sendingBtn: "Submitting…",
      sendBtn: "Submit Application",
      sentMessage: "Thanks — your application has been received. We'll be in touch.",
    },
  },
  hi: {
    nav: {
      trustedEcosystem: "विश्वसनीय पारिस्थितिकी तंत्र",
      solutions: "समाधान",
      markets: "बाज़ार",
      invest: "निवेश",
    },
    footer: {
      company: "कंपनी",
      solutions: "समाधान",
      markets: "बाज़ार",
      contactUs: "संपर्क करें",
      invest: "निवेश करें",
      careers: "करियर",
      promise: "हमारा वादा",
      values: "मूल मूल्य",
      legalTrust: "कानूनी और भरोसा",
      dataSovereignty: "डेटा संप्रभुता",
      privacyPolicy: "गोपनीयता नीति",
      termsOfUse: "उपयोग की शर्तें",
      copyright: "© 2026 Tapaswe, वैश्विक साझेदार और सहयोगी",
    },
    home: {
      heroTitleLine1: "भरोसा,",
      heroTitleLine2: "जो टिकाऊ हो।",
      heroSub:
        "हम प्लेटफ़ॉर्म बनाते हैं। स्थानीय टीमें, स्थानीय सीईओ के नेतृत्व में, बाज़ार दर बाज़ार उन्हें संचालित करती हैं — ताकि हम जिन समुदायों की सेवा करते हैं, वहाँ भरोसेमंद पारिस्थितिकी तंत्र विकसित हो सकें।",
      ctaMission: "हमारा उद्देश्य",
      solutionsEyebrow: "हमारे समाधान",
      solutionsHeading: "अब तक हमने क्या बनाया है",
      seeAllSolutions: "सभी समाधान देखें",
      marketsEyebrow: "आज दो बाज़ार",
      marketsHeading: "भारत और अमेरिका में कार्यरत",
      seeAllMarkets: "सभी बाज़ार देखें",
    },
    trustedEcosystem: {
      eyebrow: "हमारा उद्देश्य",
      headingLine1: "विश्वसनीय पारिस्थितिकी तंत्र,",
      headingLine2: "जहाँ भी हम कार्यरत हैं।",
      intro:
        "Tapaswe Global का अस्तित्व हर उस समुदाय में विश्वसनीय पारिस्थितिकी तंत्र बनाने के लिए है, जहाँ हम प्रवेश करते हैं। भरोसा कोई अतिरिक्त सुविधा नहीं है — यही कंपनी के अस्तित्व का कारण है। भारत में मुख्यालय के साथ, हम आज दो बाज़ारों से शुरुआत कर रहे हैं: भारत और अमेरिका।",
      structureEyebrow: "हमारी संरचना",
      structureHeading: "एक अभिभावक कंपनी, स्थानीय संचालक।",
      structureIntro:
        "Tapaswe Global प्लेटफ़ॉर्म बनाता है — iTrust.ID और DeviceWorks। हम जिस भी बाज़ार में कार्यरत हैं, वहाँ एक अर्ध-स्वतंत्र स्थानीय व्यवसाय, जिसका नेतृत्व एक स्थानीय सीईओ करता है, केंद्रीय रूप से बनाए गए प्लेटफ़ॉर्म का उपयोग करते हुए उस बाज़ार में वास्तविक सेवाओं और ग्राहक संबंधों का स्वामित्व रखता है। ग्लोबल बनाता है; स्थानीय संचालित करता है।",
      model: [
        "ग्लोबल प्लेटफ़ॉर्म बनाता है",
        "स्थानीय व्यवसाय उन्हें संचालित करते हैं",
        "स्थानीय सीईओ बाज़ार की वृद्धि को आगे बढ़ाते हैं",
        "आगे और बाज़ार, और समाधान",
      ],
      nextEyebrow: "आगे क्या है",
      nextHeading: "नक्शा और समाधानों की टोकरी, दोनों बढ़ रहे हैं।",
      nextIntro:
        "भारत और अमेरिका हमारी शुरुआत हैं, अंत नहीं। रूस और ऑस्ट्रेलिया हमारी योजना में आगे हैं, और हम समय के साथ iTrust.ID और DeviceWorks से आगे भी अपने समाधानों की टोकरी बढ़ाते रहने की योजना बना रहे हैं।",
    },
    promises: {
      headingLine1: "हमारा",
      headingLine2: "वादा",
      intro:
        "हम एक स्पष्ट दृष्टिकोण, पारदर्शी साझेदारी, और साझा मूल्य बनाने व देने की प्रतिबद्धता का वादा करते हैं। आज आपकी सफलता और कल आपका विकास ही हमारा उद्देश्य है।",
      items: [
        { title: "परिणाम। गारंटीशुदा।", body: "प्रतिबद्ध परिणाम देने के लिए आकांक्षा रखें, कार्य करें, मापें और ट्रैक करें।" },
        { title: "लाभ और जोखिम। साझा।", body: "साझा सफलता के लिए भागीदारी करें और जोखिमों को खुले तौर पर, संयुक्त रूप से और प्रभावी ढंग से प्रबंधित करें।" },
        { title: "पहुँच। वैश्विक।", body: "वैश्विक भागीदारों, प्रतिभा और समाधानों के साथ अपने जीवन और व्यवसाय को ऊर्जावान बनाएं।" },
        { title: "भागीदार। मित्रवत।", body: "विफलताओं का पूर्वानुमान लगाने और उनसे बचने के लिए पारदर्शिता, ईमानदारी और सहयोग का आनंद लें।" },
        { title: "अनुभव। व्यापक।", body: "सीखें, आगे बढ़ें, और टिकाऊ बदलाव को सफलतापूर्वक अपनाएं।" },
        { title: "विशेषज्ञता। गहन।", body: "पुरानी, परिपक्व, अग्रणी और उभरती हुई सोच, तकनीकों और समाधानों के साथ आगे बढ़ें।" },
        { title: "सफलता तक का समय। फुर्तीला।", body: "गतिशील योजना, अति-स्वचालन, और निरंतर दिशा-सुधार।" },
      ],
    },
    values: {
      headingLine1: "मूल",
      headingLine2: "मूल्य",
      intro: "मूल मूल्य संस्कृति और फोकस को दिशा देते हैं। हमारे पास अपने कुछ प्रकाशस्तंभ (लाइटहाउस) और ध्रुव तारे (नॉर्थ स्टार) हैं।",
      items: [
        { title: "शाश्वत = नवीनीकरण", body: "प्रकृति की तरह, हम निरंतर नवीनीकरण और प्रासंगिक बने रहने के लिए सृजन, पोषण और पुनर्चक्रण करते हैं।" },
        { title: "मानव = हृदय", body: "हम जो कुछ भी करते हैं, उसमें योग्यता, विकल्प, समानता और समावेशिता को बढ़ावा देने के लिए प्रतिबद्ध हैं।" },
        { title: "पदार्थ = मन", body: "मन ही पदार्थ, वास्तविकता और फोकस को निर्धारित करता है। जागरूकता हमें हर दिन हमारे उद्देश्य की ओर आगे बढ़ाती है।" },
        { title: "आनंद = अभी", body: "अतीत के गर्व और भविष्य के उद्देश्य से ऊपर उठकर, अभी जीवन और काम का आनंद लें।" },
        { title: "रिश्ता = पारस्परिकता।", body: "रिश्ता बराबरी वालों के लिए होता है। निर्णय की भूलों को क्षमा करें। नीयत की भूलों पर कार्रवाई करें।" },
        { title: "परिवार = भरोसा", body: "साझा भरोसा बनाना ही हमारे साथ मिलकर सहयोग करने, सीखने और सफल होने के केंद्र में है।" },
        { title: "टीम = नेटवर्क", body: "एक सबके लिए। सब एक के लिए। पूरा पारिस्थितिकी तंत्र उद्देश्यपूर्ण ढंग से एक वितरित वैश्विक टीम के रूप में कार्य करता है।" },
      ],
    },
    solutions: {
      eyebrow: "Tapaswe Global द्वारा निर्मित",
      headingLine1: "दो प्लेटफ़ॉर्म।",
      headingLine2: "दो वास्तविक समस्याएं।",
      intro:
        "प्रत्येक समाधान केंद्रीय रूप से बनाया जाता है, फिर हम जिस भी बाज़ार में हैं, वहाँ स्थानीय स्तर पर संचालित और सेवित किया जाता है। प्रत्येक का अपना ब्रांड और अपनी साइट है — लेकिन जहाँ उचित हो, वे एक साथ काम करने के लिए डिज़ाइन किए गए हैं।",
      dwBody: "DeviceWorks हर तरह के डिवाइस और उसकी फ़ील्ड सेवाओं के पूरे जीवनचक्र का प्रबंधन करता है, जो OEM और सेवा भागीदारों के साथ-साथ हमारे अपने एनालिटिक्स प्लेटफ़ॉर्म का लाभ उठाता है।",
      dwButton: "DeviceWorks पर जाएं",
      itBody: "ऐसी दुनिया में जहाँ AI हर चीज़ को आभासी और नकली बनाना आसान बना देता है, iTrust.ID का अस्तित्व हर क्षेत्र में, हर जगह — लोगों, पहचान और दावों — पर भरोसा स्थापित करने के लिए है।",
      itButton: "iTrust.ID पर जाएं",
      comingSoon: "जल्द आ रहा है",
      moreEyebrow: "और आ रहे हैं",
      moreHeading: "टोकरी लगातार बढ़ रही है।",
      moreIntro: "ये दोनों तो केवल हमारे समाधान पोर्टफोलियो की शुरुआत हैं।",
    },
    itrustComingSoon: {
      badge: "जल्द आ रहा है",
      intro1: "सबके लिए, हर जगह भरोसा। ऐसी दुनिया में जहाँ AI हर चीज़ को आभासी और नकली बनाना आसान बना देता है, iTrust.ID का अस्तित्व हर क्षेत्र में, हर जगह — लोगों, पहचान और दावों — पर भरोसा स्थापित करने के लिए है।",
      intro2: "iTrust.ID साइट और प्लेटफ़ॉर्म अभी विकासाधीन हैं। कृपया जल्द ही दोबारा देखें, या तब तक हमारे अन्य समाधान, DeviceWorks को देखें।",
      btnDeviceWorks: "DeviceWorks पर जाएं",
      btnBackSolutions: "समाधानों पर वापस जाएं",
      problemEyebrow: "समस्या",
      problemHeading: "जैसे-जैसे दुनिया आभासी होती जा रही है, भरोसा कम पड़ता जा रहा है।",
      problemBody: "डीपफेक, सिंथेटिक पहचान, और AI-जनित हर चीज़ यह जानना कठिन बना रही है कि क्या — और कौन — असली है। iTrust.ID उस एक जगह के रूप में मौजूद है जहाँ आप अपने जीवन के हर हिस्से के लिए भरोसा स्थापित, सत्यापित और प्रबंधित कर सकते हैं।",
      pillarsEyebrow: "चार स्तंभ",
      pillarsHeading: "आपके हर भरोसे के लिए एक जगह।",
      dashboardTitle: "डैशबोर्ड",
      dashboardBody: "आपके सक्रिय डिवाइस, आपके स्थान, और हर प्रमाणीकरण अनुरोध — सब एक ही दृश्य में, पूरी तरह आपके नियंत्रण में।",
      lifeTitle: "जीवन",
      lifeBody: "आपकी जीवंत पहचान: दस्तावेज़, स्वास्थ्य रिकॉर्ड, वित्तीय खाते, शिक्षा प्रमाणपत्र, और बाकी सब कुछ जो आपके सत्यापित जीवन को बनाता है।",
      peopleTitle: "लोग",
      peopleBody: "आपके जुड़े हुए समुदाय: सामाजिक दायरे, व्यवसाय, संगठन, परिवार, और पेशेवर रिश्ते — प्रत्येक की अपनी भरोसे की स्थिति के साथ।",
      thingsTitle: "वस्तुएं",
      thingsBody: "आपकी ओर से या आपके आसपास कार्य करने वाली हर चीज़: एजेंट, डिवाइस, बॉट, सर्वर, उपकरण, और ड्रोन।",
      lifecycleEyebrow: "हर वस्तु, पूरी तरह नियंत्रित",
      lifecycleHeading: "पूरा ट्रस्ट जीवनचक्र, हर जगह लागू।",
      lifecycleBody: "चारों स्तंभों में कुछ भी जोड़ें, कॉन्फ़िगर करें, और हटाएं — हर वस्तु शुरू से अंत तक ट्रैक, ऑडिट, नियंत्रित, और प्रमाणित करने योग्य है।",
      trackingTitle: "ट्रैकिंग",
      auditTitle: "ऑडिट",
      governanceTitle: "गवर्नेंस",
      certificationTitle: "प्रमाणीकरण",
    },
    markets: {
      eyebrow: "वैश्विक अभिभावक, स्थानीय संचालक",
      headingLine1: "तीन इकाइयाँ।",
      headingLine2: "एक विश्वसनीय पारिस्थितिकी तंत्र।",
      intro: "एक वैश्विक अभिभावक कंपनी प्लेटफ़ॉर्म बनाती है। स्थानीय, अर्ध-स्वतंत्र व्यवसाय — जिनका अपना ब्रांड और अपना स्थानीय सीईओ है — उन्हें ज़मीनी स्तर पर वास्तविक सेवाओं के रूप में प्रदान करते हैं।",
      globalDesc: "सभी समाधानों का स्वामी। मुंबई, महाराष्ट्र।",
      globalBtn: "ग्लोबल देखें",
      bharatDesc: "भारत परिचालन। मुंबई, महाराष्ट्र।",
      bharatBtn: "भारत देखें",
      usaDesc: "अमेरिका परिचालन। फिलाडेल्फिया और शार्लट।",
      usaBtn: "अमेरिका देखें",
      planned: "योजनाबद्ध",
      plannedDesc: "हमारे बाज़ार रोडमैप में अगला।",
      sovereigntyEyebrow: "डेटा संप्रभुता पर आधारित",
      sovereigntyHeading: "आपका डेटा वहीं रहता है, जहाँ आप हैं।",
      sovereigntyBody: "प्रत्येक बाज़ार अपने स्वतंत्र बुनियादी ढांचे पर चलता है — अपना डेटाबेस, अपनी सेवाएं, उस बाज़ार के अपने क्षेत्र में होस्ट की गई। डिफ़ॉल्ट रूप से सीमाओं के पार कुछ भी साझा नहीं किया जाता। हमारी पूरी प्रतिबद्धता डेटा संप्रभुता पृष्ठ पर पढ़ें।",
    },
    marketProfile: {
      headquarters: "मुख्यालय",
      offices: "कार्यालय",
      office: "कार्यालय",
      localLeadership: "स्थानीय नेतृत्व",
      executiveLeadership: "कार्यकारी नेतृत्व",
      solutionsTitle: "समाधान",
    },
    marketsGlobal: {
      intro: "Tapaswe Global अभिभावक इकाई है — यह iTrust.ID और DeviceWorks सहित Tapaswe पोर्टफोलियो के हर समाधान का निर्माण और स्वामित्व रखती है। प्रत्येक बाज़ार में स्थानीय संचालन व्यवसाय उन प्लेटफ़ॉर्म को ज़मीनी स्तर पर वास्तविक सेवाओं के रूप में प्रदान करते हैं।",
      solutionsNote: "स्वामित्व और निर्माण: iTrust.ID · DeviceWorks",
    },
    marketsIndia: {
      intro: "Tapaswe Bharat, Tapaswe Global की एक अर्ध-स्वतंत्र सहायक कंपनी के रूप में कार्य करती है, जो एक स्थानीय सीईओ के नेतृत्व में पूरे भारत में iTrust.ID और DeviceWorks को वास्तविक सेवाओं के रूप में प्रदान करती है।",
    },
    marketsUsa: {
      intro: "Tapaswe USA, Tapaswe Global की एक अर्ध-स्वतंत्र सहायक कंपनी के रूप में कार्य करती है, जो एक स्थानीय सीईओ के नेतृत्व में पूरे अमेरिका में iTrust.ID और DeviceWorks को वास्तविक सेवाओं के रूप में प्रदान करती है।",
    },
    invest: {
      eyebrow: "निवेशकों के लिए",
      heading: "भरोसे का बुनियादी ढांचा बना रहे हैं।",
      intro: "Tapaswe Global केंद्रीय रूप से भरोसे के प्लेटफ़ॉर्म बनाती है और उन्हें अर्ध-स्वतंत्र, स्थानीय नेतृत्व वाले संचालन व्यवसायों के माध्यम से बढ़ाती है — भारत और अमेरिका से शुरुआत करते हुए, आगे रूस और ऑस्ट्रेलिया के साथ।",
      portfolioTitle: "पोर्टफोलियो",
      portfolioBody: "iTrust.ID और DeviceWorks — और समाधान योजनाबद्ध हैं।",
      marketsTitle: "बाज़ार",
      marketsBody: "भारत और अमेरिका में सक्रिय। रूस और ऑस्ट्रेलिया अगली कतार में।",
      modelTitle: "मॉडल",
      modelBody: "ग्लोबल प्लेटफ़ॉर्म बनाता है; स्थानीय, सीईओ-नेतृत्व वाले व्यवसाय उन्हें संचालित और विकसित करते हैं।",
      getInTouchEyebrow: "संपर्क करें",
      heading2: "निवेशक पूछताछ",
      subIntro: "Tapaswe Global में निवेश के बारे में और जानने में रुचि है? हमें एक संदेश भेजें।",
      namePlaceholder: "नाम",
      emailPlaceholder: "ईमेल",
      investorTypePlaceholder: "निवेशक प्रकार",
      citizens: "नागरिक",
      smb: "छोटे और मध्यम व्यवसाय",
      corporations: "निगम",
      governments: "सरकारें",
      countryPlaceholder: "देश",
      messagePlaceholder: "संदेश",
      sendingBtn: "भेजा जा रहा है…",
      sendBtn: "पूछताछ भेजें",
      sentMessage: "धन्यवाद — आपकी पूछताछ प्राप्त हो गई है। हम जल्द ही संपर्क करेंगे।",
    },
    contact: {
      eyebrow: "संपर्क करें",
      heading: "हमसे संपर्क करें",
      intro: "हम आपसे सुनना चाहेंगे — चाहे आप एक भागीदार हों, ग्राहक हों, या बस यह जानने के इच्छुक हों कि हम क्या बना रहे हैं।",
      namePlaceholder: "नाम",
      emailPlaceholder: "ईमेल",
      entityPlaceholder: "यह किस इकाई के लिए है?",
      entityGlobal: "Tapaswe Global — वैश्विक मुख्यालय",
      entityBharat: "Tapaswe Bharat — भारत",
      entityUsa: "Tapaswe USA — अमेरिका",
      entityOther: "अन्य",
      messagePlaceholder: "संदेश",
      sendingBtn: "भेजा जा रहा है…",
      sendBtn: "भेजें",
      sentMessage: "धन्यवाद — आपका संदेश प्राप्त हो गया है। हम जल्द ही आपसे संपर्क करेंगे।",
    },
    legalDataSovereignty: {
      title: "डेटा संप्रभुता",
      sections: [
        { heading: "जल्द आ रहा है", body: "हमारी पूरी डेटा संप्रभुता प्रतिबद्धताएं अंतिम रूप ले रही हैं और जल्द ही यहाँ प्रकाशित की जाएंगी। हम जिस भी बाज़ार में कार्यरत हैं, वह अपने स्वतंत्र बुनियादी ढांचे पर चलता है, जो उस बाज़ार के अपने क्षेत्र में होस्ट किया गया है।" },
      ],
    },
    legalPrivacy: {
      title: "गोपनीयता नीति",
      sections: [
        { heading: "जल्द आ रहा है", body: "हमारी गोपनीयता नीति अंतिम रूप ले रही है और जल्द ही यहाँ प्रकाशित की जाएगी।" },
      ],
    },
    legalTerms: {
      title: "उपयोग की शर्तें",
      sections: [
        { heading: "जल्द आ रहा है", body: "हमारी उपयोग की शर्तें अंतिम रूप ले रही हैं और जल्द ही यहाँ प्रकाशित की जाएंगी।" },
      ],
    },
    noPage: {
      heading: "पृष्ठ नहीं मिला",
      body: "आप जिस पृष्ठ की तलाश कर रहे हैं वह मौजूद नहीं है या स्थानांतरित हो गया है।",
      button: "होम पर वापस जाएं",
    },
    legalPage: {
      eyebrow: "कानूनी",
    },
    deviceworks: {
      navMarketplace: "मार्केटप्लेस",
      navCompare: "तुलना करें",
      navLifecycle: "जीवनचक्र",
      navHowWeWork: "हम कैसे काम करते हैं",
      navGetAQuote: "कोटेशन प्राप्त करें",
      home: {
        eyebrow: "डिवाइस जीवनचक्र, सरल बनाया गया",
        heroTitleLine1: "हर डिवाइस।",
        heroTitleLine2: "एक भागीदार।",
        heroSub: "DeviceWorks हर तरह के डिवाइस और उसकी फ़ील्ड सेवाओं के पूरे जीवनचक्र का प्रबंधन करता है — OEM और सेवा भागीदारों के साथ-साथ हमारे अपने एनालिटिक्स प्लेटफ़ॉर्म का लाभ उठाते हुए, ताकि आप दर्जनों की बजाय एक जवाबदेह भागीदार के साथ काम करें।",
        ctaQuote: "कोटेशन प्राप्त करें",
        ctaHowWeWork: "हम कैसे काम करते हैं",
        pullQuote: "\"डिवाइस फ्लीट वह चीज़ नहीं होनी चाहिए जिसके बारे में ऑपरेशंस को सोचना पड़े। इसे बस काम करना चाहिए — और जब यह न करे, तो किसी को पहले से ही इस पर काम कर रहा होना चाहिए।\"",
        howItWorksEyebrow: "यह कैसे काम करता है",
        howItWorksHeading: "तीन चरण, शुरू से अंत तक",
        step1Title: "हमें बताएं आपको क्या चाहिए",
        step1Body: "डिवाइस, मात्रा, समय-सीमा — हम आपके साथ मिलकर इसकी योजना बनाते हैं।",
        step2Title: "हम क्रियान्वयन का समन्वय करते हैं",
        step2Body: "सोर्सिंग, तैनाती, और फ़ील्ड सेवा हमारे भागीदार नेटवर्क के माध्यम से संभाली जाती है।",
        step3Title: "आपको एक डैशबोर्ड मिलता है",
        step3Body: "हर डिवाइस, हर भागीदार का एनालिटिक्स और स्थिति, एक ही जगह।",
        marketplaceComingSoon: "जल्द आ रहा है",
        marketplaceTitle: "डिवाइस मार्केटप्लेस",
        marketplaceBody: "नए, प्रमाणित नवीनीकृत, और OEM डिवाइस — श्रेणी के अनुसार चुने गए।",
        marketplaceLink: "मार्केटप्लेस देखें",
        lifecycleTitle: "जीवनचक्र सेवाएं",
        lifecycleBody: "खरीद, चल रहा प्रबंधन, मरम्मत, और अंतिम निपटान — शुरू से अंत तक।",
        lifecycleLink: "सभी सेवाएं देखें",
        industriesEyebrow: "हम किनकी सेवा करते हैं",
        industriesHeading: "उद्योग",
        industryRetail: "खुदरा",
        industryDistribution: "वितरण",
        industryWarehousing: "गोदाम प्रबंधन",
        industryManufacturing: "विनिर्माण",
        ctaHeading: "अपने डिवाइस फ्लीट को सरल बनाने के लिए तैयार हैं?",
        ctaSub: "हमें बताएं आप किसके साथ काम कर रहे हैं — बाकी हम संभाल लेंगे।",
        ctaButton: "कोटेशन प्राप्त करें",
      },
      pageHeaders: {
        marketplace: { eyebrow: "जल्द आ रहा है", title: "डिवाइस मार्केटप्लेस", description: "आने वाली चीज़ों की एक चयनित झलक — अभी लाइव, ब्राउज़ करने योग्य कैटलॉग नहीं है। यहाँ बताया गया है कि क्या उम्मीद करें।" },
        compare: { eyebrow: "डिवाइस तुलना करें", title: "सही विकल्प खोजें", description: "दस त्वरित प्रश्न — हम आपको सही श्रेणी की ओर इंगित करेंगे।" },
        lifecycleServices: { eyebrow: "हम क्या करते हैं", title: "जीवनचक्र सेवाएं", description: "चार सेवा क्षेत्र, एक जवाबदेह भागीदार, शुरू से अंत तक।" },
        howWeWork: { eyebrow: "संचालन मॉडल", title: "हम कैसे काम करते हैं", description: "दो आपूर्ति श्रृंखलाएं, साथ मिलकर काम करती हुई, एक के रूप में प्रबंधित।" },
        insights: { eyebrow: "अंतर्दृष्टि", title: "डिवाइस परिचालन पर नोट्स" },
        industries: { eyebrow: "हम किनकी सेवा करते हैं", title: "जिन उद्योगों की हम सेवा करते हैं" },
        oemPartners: { eyebrow: "खुदरा फोकस — सभी क्षेत्रों में विस्तार", title: "OEM भागीदार", description: "हम आपको किसी एक तक सीमित रखने के बजाय कई डिवाइस निर्माताओं के साथ काम करते हैं — विक्रेता-निष्पक्षता हमारी सलाह के केंद्र में है।" },
        logisticsPartners: { eyebrow: "भौतिक आपूर्ति श्रृंखला", title: "लॉजिस्टिक्स भागीदार", description: "हमारा लॉजिस्टिक्स नेटवर्क जो क्षमताएं प्रदान करता है — यहाँ जानबूझकर कोई भागीदार नाम सूचीबद्ध नहीं है, हमारे विक्रेता-निष्पक्ष दृष्टिकोण के अनुरूप।" },
        getAQuote: { eyebrow: "कोटेशन प्राप्त करें", title: "हमें बताएं आपको क्या चाहिए", description: "कुछ विवरण दें और हमारी टीम अगले कदमों के साथ संपर्क करेगी।" },
        contact: { eyebrow: "संपर्क करें", title: "हमसे संपर्क करें" },
        about: { eyebrow: "हमारे बारे में", title: "DeviceWorks क्यों मौजूद है" },
        locations: { eyebrow: "हम कहाँ हैं", title: "स्थान" },
        login: { eyebrow: "जल्द आ रहा है", title: "क्लाइंट लॉगिन", description: "DeviceWorks एनालिटिक्स प्लेटफ़ॉर्म अभी विकासाधीन है।" },
      },
    },
    careers: {
      eyebrow: "हमसे जुड़ें",
      heading: "खुले पद",
      intro: "हम एक छोटी, सोच-समझकर बनाई गई टीम हैं। ये तीन पद अभी खुले हैं।",
      roleBharatTitle: "मुख्य कार्यकारी अधिकारी (CEO)",
      roleBharatEntity: "Tapaswe Bharat",
      roleBharatLocation: "मुंबई, महाराष्ट्र",
      roleBharatBody: "हमारे भारत संचालन व्यवसाय का पूर्णकालिक नेतृत्व करें — यह पद अभी हमारे मुख्य ट्रस्ट अधिकारी द्वारा अस्थायी रूप से संभाला जा रहा है।",
      roleUsaTitle: "मुख्य कार्यकारी अधिकारी (CEO)",
      roleUsaEntity: "Tapaswe USA",
      roleUsaLocation: "फिलाडेल्फिया, PA या शार्लट, NC",
      roleUsaBody: "हमारे अमेरिका संचालन व्यवसाय का नेतृत्व करें — स्थानीय टीम का निर्माण, बाज़ार में हमारे दोनों समाधानों को बढ़ाना, और Tapaswe Global संरचना को रिपोर्ट करना।",
      roleGlobalTitle: "मुख्य उत्पाद अधिकारी (CPO)",
      roleGlobalEntity: "Tapaswe Global",
      roleGlobalLocation: "मुंबई, महाराष्ट्र",
      roleGlobalBody: "हमारे समाधान पोर्टफोलियो — iTrust.ID, DeviceWorks, और आगे जो भी आए — में उत्पाद दिशा का स्वामित्व लें, अभिभावक कंपनी के नेतृत्व के साथ सीधे काम करते हुए।",
      applyHeading: "आवेदन करें",
      applySub: "हमें अपने बारे में थोड़ा बताएं और आप किस पद के लिए आवेदन कर रहे हैं।",
      namePlaceholder: "नाम",
      emailPlaceholder: "ईमेल",
      rolePlaceholder: "कौन सा पद?",
      linkPlaceholder: "रिज़्यूमे, LinkedIn, या पोर्टफोलियो का लिंक (वैकल्पिक)",
      attachmentsLabel: "अनुलग्नक",
      attachmentsHint: "रिज़्यूमे, कवर लेटर, पोर्टफोलियो — कई फ़ाइलें भेज सकते हैं।",
      messagePlaceholder: "संदेश",
      sendingBtn: "भेजा जा रहा है…",
      sendBtn: "आवेदन जमा करें",
      sentMessage: "धन्यवाद — आपका आवेदन प्राप्त हो गया है। हम जल्द ही संपर्क करेंगे।",
    },
  },
};

export default translations;
